import React, { useState } from "react";
import { ButtonHeading } from "components";
import useDocumentTitle from "hooks/useDocumentTitle";
import images from "constants/images";
import { GpsIntigrationModal } from "modals";
import AddGpsModal from "modals/AddGpsModal";

const gpsVendors = [
    { id: 1, name: "Fleetx", buttonText: "Fleetx", type: "fleetx", url: "" },
    { id: 2, name: "Wheelseye (User ID)", buttonText: "Wheelseye", type: "wheelseye", url: "" },
    // Add more vendors as needed
];

const Gps = () => {
    useDocumentTitle("Fuel Card | T360");

    const [isOpenWheelseye, setIsOpenWheelseye] = useState(false);
    const [isOpenFleetx, setIsOpenFleetx] = useState(false);

    let fleetxProps = {
        isOpen: isOpenFleetx,
        closeModal: (e) => setIsOpenFleetx(false),
        footerPart: true,
        modalMainClass: "_dashCommon_Modal ",
        modalTitle: isOpenFleetx ? "Integrate Fleetx" : 'Integrate Wheelseye',
        submitTitle: isOpenFleetx ? "Integrate" : 'Integrate',
    }

    let wheelseyeProps = {
        isOpen: isOpenWheelseye,
        closeModal: (e) => setIsOpenWheelseye(false),
        footerPart: true,
        modalMainClass: "_dashCommon_Modal ",
        modalTitle: isOpenFleetx ? "Integrate Fleetx" : 'Integrate Wheelseye',
        submitTitle: isOpenFleetx ? "Integrate" : 'Integrate',
    }
    return (
        <div className="__profilCmp_main setting-nw-parentBx">
            <ButtonHeading
                className="commonHeading_title"
                title={"GPS Integration"}
                showSearchFilter={{ filterCount: true }}
                section="settings"
            />

            <div className="addPr_flBx nrml-tbl">
                <div className="_mainFc_hv">
                    <div className="accordion _gps_acc" id="quickUploadAccordion">
                        {gpsVendors.map((vendor, index) => (
                            <div className="accordion-item" key={vendor.id}>
                                <h2 className="accordion-header">
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse${index}`}
                                        aria-expanded={index === 0 ? "true" : "false"}
                                        aria-controls={`collapse${index}`}
                                    >
                                        <div className="_msxFlx">
                                            <p>{vendor.name}</p>
                                        </div>
                                    </button>
                                </h2>
                                <div
                                    id={`collapse${index}`}
                                    className={`accordion-collapse collapse ${index === 0 ? "show" : ""}`}
                                    data-bs-parent="#quickUploadAccordion"
                                >
                                    <div className="accordion-body">
                                        <div className="gps_details">
                                            <p>Integrate {vendor.name} with RoaDo to enable GPS tracking for your vehicles.</p>
                                            <div className="gps_buttons">
                                                <div className="url_button_div">
                                                    <img src={images?.WWW} alt="Visit icon" />
                                                    <a rel="noopener noreferrer">
                                                        <button className="url_button">Visit {vendor.buttonText}</button>
                                                    </a>
                                                </div>
                                                <div className="_rSideBtn">
                                                    <button
                                                        className="_addComm_btn"
                                                        onClick={() => {
                                                            vendor?.type == "fleetx" ? setIsOpenFleetx(true) : setIsOpenWheelseye(true)
                                                        }}
                                                    >
                                                        Integrate {vendor.buttonText}
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {isOpenFleetx && <AddGpsModal {...fleetxProps} />}
            {isOpenWheelseye && <AddGpsModal {...wheelseyeProps} />}
        </div>
    );
};

export default Gps;
